import { Component, EventEmitter, Input, Output } from '@angular/core';
import { pageAnimation } from '@app/shared/animations/page-animations';

@Component({
  selector: 'app-smash-image',
  templateUrl: './smash-image.component.html',
  styleUrls: ['./smash-image.component.scss'],
  animations: [
    pageAnimation
  ]
})
export class SmashImageComponent {

  @Input() url: string;
  @Input() type: string;
  @Output() imageReadyEvent: EventEmitter<boolean> = new EventEmitter();

  imageIsReady = false;

  constructor() { }

  imageReady($event) {
    this.imageReadyEvent.emit(true);
    this.imageIsReady = true;
  }
}
